<template>
  <div v-if="loadingDone">
    <v-row v-for="tenant in tenants" :key="tenant.code">
      <v-col>
        <v-card>
          <v-card-title>
            {{ tenant.name }}
          </v-card-title>
          <v-list>
            <deployment-tenant
              v-for="(tenantPreset, index) in tenant.presets"
              :key="index"
              :deployment="tenantPreset.deployment"
              :preset="tenantPreset.code"
              :logo="tenantPreset.logo"
            />
          </v-list>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="false && $admin.can('ROLE_ADMIN')">
      <v-col>
        <dev-deployments id="stg" />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import restProvider from "@/providers/restProvider";
import admin from "@/plugins/admin";
import { GET_LIST } from "@skuhnow/vuetify-admin/src/providers/data/actions";
import DeploymentTenant from "@/components/dashboard/DeploymentTenant";
import DevDeployments from "@/components/dashboard/DevDeployments";

export default {
  components: { DevDeployments, DeploymentTenant },
  data() {
    return {
      tenants: null,
      loadingDone: false
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      const responseTenantsRaw = await restProvider(admin.http)[GET_LIST]("companies", {
        filter: {
          group: "tenant"
        },
        pagination: { page: 1, perPage: 999 }
      });
      const responseDeployments = await restProvider(admin.http)[GET_LIST]("deployments", {
        pagination: { page: 1, perPage: 999 }
      });
      const responsePresets = await restProvider(admin.http)[GET_LIST]("presets", {
        pagination: { page: 1, perPage: 999 }
      });

      let presets = responsePresets.data;
      let cmsPresetsByCode = {};
      presets.forEach(preset => {
        cmsPresetsByCode[preset.code] = preset;
      });

      const tenantsRaw = responseTenantsRaw.data;
      let tenantsByCode = {};
      tenantsRaw.forEach(tenantRaw => {
        tenantsByCode[tenantRaw.code] = tenantRaw;
      });

      let deployments = responseDeployments.data;
      let tenants = {};
      deployments.map(deployment => {
        Object.keys(deployment.config.presets).map(presetCode => {
          let tenantCode = deployment.config.presets[presetCode];

          if (tenantCode === "integration") {
            return;
          }

          let preset = {
            code: presetCode,
            logo: cmsPresetsByCode[presetCode] ? cmsPresetsByCode[presetCode].logo : null,
            deployment: deployment
          };

          if (tenants[tenantCode]) {
            tenants[tenantCode].presets.push(preset);
          } else {
            tenants[tenantCode] = {
              code: tenantCode,
              name: tenantsByCode[tenantCode] ? tenantsByCode[tenantCode].name : "unknown (" + tenantCode + ")",
              presets: [preset]
            };
          }
        });
      });

      this.tenants = Object.values(tenants);
      this.loadingDone = true;
    }
  }
};
</script>
